export const ConsumerPhoneValidationSectionFormStyles = {
  container: 'flex justify-center',
}
